"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _stripe = require("../stripe");
const useStripePromise = stripeKey => {
  const [stripePromise, setStripePromise] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (stripeKey) {
      setStripePromise((0, _stripe.loadStripe)(stripeKey));
    }
  }, [stripeKey]);
  return stripePromise;
};
var _default = exports.default = useStripePromise;